module.exports = __webpack_public_path__ + "img/leakalert_header.1a43ae48.png";